import React, { useCallback } from 'react';
import type { ComponentMap } from '@atlassian/forge-ui';
import { ExtensionPointProvider } from '@atlassian/help-center-common-component/forge-ui/extension-point-provider';
import { ExtensionProvider } from '@atlassian/help-center-common-component/forge-ui/extension-provider';
import { Renderer } from '@atlassian/help-center-common-component/forge-ui/renderer';
import { TopLevelComponent } from '@atlassian/help-center-common-component/forge-ui/top-level-component';
import type {
    CustomField,
    CustomFieldType,
    ExtensionData,
    ExtensionPayload,
} from '@atlassian/help-center-common-component/forge-ui/types';

export interface Props {
    extension: CustomField | CustomFieldType;
    extensionData: ExtensionData;
    extensionPayload: ExtensionPayload;
}

export const ForgeCustomFieldEdit = ({ extension, extensionData, extensionPayload }: Props) => {
    const getComponents = useCallback(
        (defaults: ComponentMap) => ({
            ...defaults,
            CustomField: TopLevelComponent,
        }),
        []
    );

    return (
        <ExtensionPointProvider extensionType={extension.type}>
            <ExtensionProvider extension={extension}>
                <Renderer
                    extension={extension}
                    extensionData={extensionData}
                    extensionPayload={extensionPayload}
                    getComponents={getComponents}
                    entryPoint="edit"
                />
            </ExtensionProvider>
        </ExtensionPointProvider>
    );
};
